import type { NextRouter } from 'next/router';

/**
 * Reads the current session id from the Next.js router query, handling both
 * the legacy `[id]` (string) and new `[[...id]]` (string[]) route shapes.
 * Returns `''` when no session id is present.
 */
export function getCurrentRouteSessionId(router: NextRouter): string {
  const routeId = router.query.id;
  if (Array.isArray(routeId)) return routeId[0] ?? '';
  return routeId ?? '';
}
